export default __webpack_public_path__ + "static/media/logo.fa38019c.svg";